import { createResource } from '@atlassian/react-resource-router';
import { getProjectKeyId } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { ViewsResponse } from './types.tsx';

export const SUMMARY_PAGE_VIEWS_RESOURCE_KEY = 'SERVICE_DESK_PROJECT_SUMMARY_VIEWS';

export const summaryPageViewsResource = createResource<ViewsResponse>({
	type: SUMMARY_PAGE_VIEWS_RESOURCE_KEY,
	getKey: ({ match, query }) => {
		const { projectKey } = getProjectKeyId(match, query);
		return `${SUMMARY_PAGE_VIEWS_RESOURCE_KEY}_${projectKey}`;
	},
	getData: async ({ match, query }, { tenantContext: { activationId: workspaceId } }) => {
		const { projectKey } = getProjectKeyId(match, query);
		return fg('jsm_project_summary_avp_m0_reporting_dev_endpoint')
			? performGetRequest<ViewsResponse>(
					`/gateway/api/jsm/reporting-dev/jira/workspace/${workspaceId}/project/${projectKey}/v1/views`,
				)
			: performGetRequest<ViewsResponse>(
					`/gateway/api/jsm/reporting/jira/workspace/${workspaceId}/project/${projectKey}/v1/views`,
				);
	},
});
